import { render, staticRenderFns } from "./iconDelete.vue?vue&type=template&id=3c42d8d8&scoped=true"
import script from "./iconDelete.vue?vue&type=script&lang=js"
export * from "./iconDelete.vue?vue&type=script&lang=js"
import style0 from "./iconDelete.vue?vue&type=style&index=0&id=3c42d8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42d8d8",
  null
  
)

export default component.exports